import React from 'react';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import { isRightButtonsVisible } from 'app/features/header/selectors';
import { isMigrationLandingPath } from 'app/features/migration/landing/selectors';
import S from 'app/features/header/components/Header.styled';
import LogoButton from 'app/features/header/components/buttons/LogoButton';
import ExploreButton from 'app/features/header/components/buttons/ExploreButton';
import LoginButton from 'app/features/header/components/buttons/LoginButton';

const UI = ({ isRightButtonsVisible, isBlackBackgroundVisible }) => (
  <>
    {isBlackBackgroundVisible && (
      <S.BlackBackground data-t="header-black-background" />
    )}
    <S.Header>
      <LogoButton />
      {isRightButtonsVisible && (
        <S.Header.ButtonHolder>
          <LoginButton />
          <ExploreButton />
        </S.Header.ButtonHolder>
      )}
    </S.Header>
  </>
);

UI.propTypes = {
  isRightButtonsVisible: PropTypes.bool.isRequired,
  isBlackBackgroundVisible: PropTypes.bool.isRequired,
};

UI.displayName = 'Header';

const Header = connect({
  isRightButtonsVisible,
  isBlackBackgroundVisible: isMigrationLandingPath,
})(UI);

export { UI };

export default Header;
